import { useState } from 'react';

import { useTranslation } from '../../i18n/useTranslation.js';

const COLUMNS = ['TODO', 'IN_PROGRESS', 'REVIEW', 'DONE'];

export function KanbanBoard({ tasks, onMove }) {
  const { t } = useTranslation();
  const [dragId, setDragId] = useState(null);
  const [overCol, setOverCol] = useState(null);

  const byColumn = (status) => tasks.filter((task) => task.status === status);

  const handleDrop = (status) => {
    if (dragId) {
      const count = byColumn(status).length;
      onMove(dragId, { status, position: count });
    }
    setDragId(null);
    setOverCol(null);
  };

  return (
    <div className="kanban">
      {COLUMNS.map((status) => {
        const items = byColumn(status);
        return (
          <div
            key={status}
            className={`kanban-col${overCol === status ? ' drop-target' : ''}`}
            onDragOver={(e) => { e.preventDefault(); setOverCol(status); }}
            onDragLeave={() => setOverCol(null)}
            onDrop={() => handleDrop(status)}
          >
            <div className="kanban-col-title">{t(`task.status.${status}`)} · {items.length}</div>
            {items.map((task) => (
              <div
                key={task.id}
                className={`kanban-card priority-${task.priority.toLowerCase()}${dragId === task.id ? ' dragging' : ''}`}
                draggable
                onDragStart={() => setDragId(task.id)}
                onDragEnd={() => { setDragId(null); setOverCol(null); }}
              >
                <div className="kanban-card-title">{task.title}</div>
                <div className="kanban-card-meta">
                  {task.assigneeName && <span>👤 {task.assigneeName}</span>}
                  {task.priority === 'HIGH' && <span>🔴 {t('task.priority.HIGH')}</span>}
                </div>
              </div>
            ))}
          </div>
        );
      })}
    </div>
  );
}
